"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var material_1 = require("@mui/material");
var trans_1 = __importDefault(require("@/plugins/trans"));
var helpers_1 = require("@/frontend/helpers");
var LocalApplicationContext_1 = __importDefault(require("./context/LocalApplicationContext"));
var useIsSmallScreen_1 = __importDefault(require("../hooks/useIsSmallScreen"));
var SelectRecruiter = function (_a) {
    var recruiter = _a.recruiter, setRecruiterId = _a.setRecruiterId;
    var _b = (0, react_query_1.useQuery)('possibleRecruiters', function () {
        return axios_1.default.get('/data/recruiters/possible').then(function (result) { return result.data; });
    }), data = _b.data, isLoading = _b.isLoading;
    (0, react_1.useEffect)(function () {
        if (recruiter) {
            setRecruiterId(recruiter.id);
        }
    }, [recruiter, setRecruiterId]);
    if (recruiter) {
        return (0, jsx_runtime_1.jsx)("div", { children: recruiter.name });
    }
    if (isLoading || !data) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ id: "selectRecruiter" }, { children: trans_1.default.get('columns.application.recruiter') })), (0, jsx_runtime_1.jsxs)(material_1.Select, __assign({ defaultValue: 0, labelId: "selectRecruiter", onChange: function (event) { return setRecruiterId(event.target.value); } }, { children: [(0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: 0 }, { children: trans_1.default.get('labels.frontend.applications.no_recruiter') })), (0, lodash_1.map)(data, function (name, id) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: id }, { children: name }), id)); })] }))] })));
};
function ApplicationHiredModal() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(null), rating = _a[0], setRating = _a[1];
    var _b = (0, react_1.useState)(0), recruiterId = _b[0], setRecruiterId = _b[1];
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var currentApplication = (0, react_1.useContext)(LocalApplicationContext_1.default).currentApplication;
    var handleClose = function () {
        navigate(-1);
    };
    if (!currentApplication || !(currentApplication === null || currentApplication === void 0 ? void 0 : currentApplication.contract)) {
        return null;
    }
    var handleSubmit = function () {
        axios_1.default
            .post("/data/applications/".concat(currentApplication.id, "/hired"), {
            recruiter_id: recruiterId,
            has_recruiter_id: !!recruiterId,
            recruiter_rating: rating,
        })
            .then(function (_a) {
            var data = _a.data;
            if (data.toasty) {
                (0, helpers_1.toasty)({ message: data.toasty.message, type: data.toasty.type });
            }
            navigate("/applications/completed/".concat(currentApplication.id, "/about"));
        })
            .catch(function (error) {
            (0, helpers_1.toasty)({
                message: error.response.data.message || error.response.statusText,
                type: 'error',
            });
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ fullScreen: isSmallScreen, open: true, onClose: handleClose }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, __assign({ color: "primary.dark", sx: { fontWeight: 'bold' } }, { children: trans_1.default.get('labels.general.confirm', { Entity: trans_1.default.get('labels.general.contract') }) })), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 8 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, gap: 4, display: "flex" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ fontWeight: "bold" }, { children: [trans_1.default.get('columns.contract.contract_hours'), ":"] })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "primary.dark" }, { children: currentApplication.contract.hours }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, gap: 4, display: "flex" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ fontWeight: "bold" }, { children: [trans_1.default.get('columns.contract.start_date'), ":"] })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "primary.dark" }, { children: currentApplication.contract.startDate }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, gap: 4, display: "flex" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ fontWeight: "bold" }, { children: [trans_1.default.get('columns.contract.end_date'), ":"] })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "primary.dark" }, { children: currentApplication.contract.endDate }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(SelectRecruiter, { recruiter: currentApplication === null || currentApplication === void 0 ? void 0 : currentApplication.recruiter, setRecruiterId: setRecruiterId }) })), recruiterId > 0 && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.Rating, { value: rating, onChange: function (event, newValue) { return setRating(newValue); }, size: "large" }) })))] })) }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: handleClose }, { children: trans_1.default.get('buttons.general.cancel') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", onClick: handleSubmit }, { children: trans_1.default.get('buttons.general.confirm') }))] })] })));
}
exports.default = ApplicationHiredModal;
